import { FC } from 'react';
import { Button } from '@mui/material';
import { useCSVDownloader } from 'react-papaparse';
import { AvaSuburbs } from '@models';

type Props = {
  rows: AvaSuburbs[];
};

export const AvaSuburbListDownloadCsvModal: FC<Props> = ({ rows }) => {
  const { CSVDownloader } = useCSVDownloader();

  const excludeStoreRanking = (rows: AvaSuburbs[]) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    return rows.map(({ _id, store_ranking, ...rest }) => rest);
  };

  return (
    <CSVDownloader data={() => excludeStoreRanking(rows)} filename={`jimbo-ava-suburb-list-export-${new Date().toISOString()}`}>
      <Button variant="contained" data-testid="ava-suburb-list-download-btn">
        Download CSV
      </Button>
    </CSVDownloader>
  );
};
